export function useTrackReferral() {
  return (user: {email: string}) => {
    window.fpr('referral', {email: user.email})
  }
}
